<template>
    <div class="content">
        <div class="content-view">
            <div class="content-head">延保服务试算</div>
            <el-descriptions title="" :column="1" size="medium" labelClassName="custom-label">
                <el-descriptions-item label="订单号">
                    <el-input  autocomplete="on" name="QRCode" v-model="params.orders_sn" placeholder="请输入电商订单号或电商订单ERP订单号进行查询，多个之间以;分隔" style="width: 500px"></el-input>
                </el-descriptions-item>
                <el-descriptions-item label="延保类型">
                    <el-radio-group v-model="params.service_type">
                        <el-radio :label="item.Value" v-for="item in service_type_list" :key="item.Value">
                            {{ item.Name }}
                            <img src="@/assets/images/wenhao.png" :alt="item.remarks" :title="item.remarks" class="Tips" />
                        </el-radio>
                    </el-radio-group>
                </el-descriptions-item>
                <el-descriptions-item label="延保时长">
                    <el-radio-group v-model="params.year">
                        <el-radio :label="item.value" v-for="item in yearList" :key="item.value">{{ item.name }}</el-radio>
                    </el-radio-group>
                </el-descriptions-item>
            </el-descriptions>
            <div>
                <span class="custom-label" style="margin-right: 10px"></span>
                <el-button type="primary" @click="GetWarrantyExtendResultList">开始试算</el-button>
                <el-button type="primary" v-if="extendResultList && extendResultList.length > 0" @click="WarrantyExtendResultExport">导出数据</el-button>
            </div>
            <div v-if="emptyWhy">
                <div class="mt20">
                    {{ emptyWhy || '目标订单不包含支持延保产品细目，暂不支持延保服务试算' }}
                </div>
            </div>
            <div class="mt20" v-if="extendResultList && extendResultList.length > 0">
                <div class="cart-list-container">
                    <div class="cart-list" v-for="(item, index) in extendResultList" :key="index">
                        <div class="flex">
                            <div class="mb10">
                                <span class="mr30">订单号：{{ item.orders_sn }}</span>
                                <span class="mr30">客户名称：{{ item.customer_name }}</span>
                                <span class="mr30">工程名称：{{ item.project_name }}</span>
                            </div>
                        </div>
                        <div>
                            <div>
                                <el-table :data="item.detailInfos" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                    <el-table-column prop="product_code" label="产品编码" align="center"></el-table-column>
                                    <el-table-column prop="product_name" label="产品名称" width="400" align="center" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="product_spce" label="型号规格" align="center"></el-table-column>
                                    <el-table-column prop="数量" label="数量" align="center"></el-table-column>
                                    <el-table-column prop="price" label="面价" align="center">
                                        <template slot-scope="scope">
                                            <span>￥{{ scope.row.price.toFixed(2) }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="proportion" label="延保比例" align="center"></el-table-column>
                                    <el-table-column prop="proportion_price" label="延保费用" align="center">
                                        <template slot-scope="scope">
                                            <span>￥{{ scope.row.proportion_price.toFixed(2) }}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </div>
                    <div class="total">
                        费用合计:
                        <span>￥{{ combined.toFixed(2) || 0 }}</span>
                    </div>
                    <div class="tipBottom">
                        <p>该测算结果为延保费用的最低报价，如需根据项目实际情况上调报价，请导出后更改报价结果。</p>
                        <p>如需签订延保服务订单，请联系消防服务部。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            params: {
                orders_sn: '',
                service_type: '0',
                year: 1
            },
            WarrantyList: [], // 延保服务
            service_type_list: [],
            yearList: [], // 延保时长
            extendResultList: [], // 延保服务试算结果
            combined: 0, // 延保服务试算结果
            emptyWhy: '' // 延保服务试算结果为空时的提示信息
        };
    },
    mounted() {
        this.WarrantyextendInitialization();
    },
    methods: {
        WarrantyextendInitialization() {
            this.$newsApi.WarrantyextendInitialization(this.params).then((res) => {
                this.WarrantyList = res.data.data;
                this.service_type_list = this.WarrantyList.Services_Type;
                this.yearList = Object.entries(this.WarrantyList.Year).map(([value, name]) => ({
                    value: Number(value), // 如果希望value是数字类型
                    name
                }));
            });
        },
        // 延保服务试算
        GetWarrantyExtendResultList() {
            if (!this.params.orders_sn) {
                this.$message({ message: '请输入订单号', type: 'error' });
                return;
            }
            let Json = JSON.stringify(this.params);
            this.$newsApi
                .GetWarrantyExtendResultList({
                    Json: Json
                })
                .then((res) => {
                    this.extendResultList = res.data.data;
                    if (res.data.data) {
                        this.combined = this.extendResultList.flatMap((item) => item.detailInfos).reduce((sum, items) => sum + items.proportion_price, 0);
                        this.emptyWhy = '';
                    } else {
                        this.emptyWhy = res.data.Resultinfo;
                    }
                });
        },
        WarrantyExtendResultExport() {
            let Json = {
                yearnum: this.params.year,
                services_type: this.params.service_type,
                qrcode: this.params.orders_sn
            };
            this.$newsApi.WarrantyExtendResultExport(Json).then((res) => {
                if (res.data.data) {
                    window.open(this.$fileUrl + res.data.data, '_blank');
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/.custom-label {
    // background: #f5f7fa !important;
    max-width: 150px !important;
    min-width: 120px !important;
    line-height: 30px;
    display: inline-block;
    text-align: right !important;
}
/deep/.el-form-item__label {
    font-weight: 500 !important;
}
/deep/ .el-descriptions-item__content {
    display: flex;
    align-items: center;
}
.el-radio {
    margin-right: 10px !important;
}
.Tips {
    width: 16px;
    height: 16px;
    vertical-align: top;
    margin-right: 10px;
}
.content-view {
    height: 100%;
    background: #fff;
    padding: 0px 20px 20px 20px;
}
.content-head {
    line-height: 50px;
    padding-bottom: 0px;
}
.cart-list-container {
    border: 1px solid #e4e7ed;
    border-radius: 15px;
    padding: 20px 25px 10px 25px;
}
.cart-list {
    background-color: #ffffff;
    font-size: 14px;
    .cart-top {
        font-weight: 700;
        margin-bottom: 10px;
        .cart-top-title {
            .title-contetn {
                font-size: 14px;
                margin-right: 10px;
            }
        }
    }
    .cart-top-title-big {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 10px;
    }
}
.total {
    font-size: 14px;
    text-align: right;
    margin-top: 10px;
    span {
        color: red;
        padding-right: 20px;
    }
}
.flex {
    display: flex;
    align-items: center;
}
.tipBottom {
    p {
        font-size: 14px;
        margin-top: 10px;
        color: red;
    }
}
</style>
